import { render } from "./ToggleVigenciaButton.vue?vue&type=template&id=0a524ca9&scoped=true"
import script from "./ToggleVigenciaButton.vue?vue&type=script&lang=js"
export * from "./ToggleVigenciaButton.vue?vue&type=script&lang=js"

import "./ToggleVigenciaButton.vue?vue&type=style&index=0&id=0a524ca9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a524ca9"]])

export default __exports__